import React from "react";
import DataField from "../../../utils/DataField";
import { useTranslation } from "react-i18next";

function ItauCard(props) {

    const { t } = useTranslation()
    const { itauData } = props

    const mapRiskClassification = (value) => {
        switch (value) {
            case 'NONE':
                return 'INDÍSPONÍVEL'
            case 'VERY_LOW':
                return 'MUITO BAIXO'
            case 'LOW':
                return 'BAIXO'
            case 'MEDIUM':
                return 'MÉDIO'
            case 'HIGH':
                return 'ALTO'
            case 'VERY_HIGH':
                return 'MUITO ALTO'
            default:
                return 'INDÍSPONÍVEL'
        }
    }

    return (
        <div className="analysisCard" style={{ height: "100%" }}>
            <div className={["blueText", "subtitleSize"].join(" ")}>{t("Itaú - Score de cŕedito")}</div>
            <div className="internalCardContainer" style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ alignItems: 'center', display: 'flex' }}>
                    <DataField
                        title={t("Score")}
                        label={itauData?.score ?? "Indisponível"}
                        size={"normalMediumSize"}
                        titleNoWrap={false}
                    />
                </div>
                <div style={{ alignItems: 'center', display: 'flex' }}>
                    <DataField
                        title={t('risk_level')}
                        label={mapRiskClassification(itauData?.nivel_risco) ?? "Indisponível"}
                        size={"normalMediumSize"}
                        titleNoWrap={false}
                    />
                </div>
            </div>
        </div>
    );
}

export default ItauCard;